export default __webpack_public_path__ + "static/media/unicorn.2957b189.gif";